import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Paper, Card, CardContent, Divider } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import * as XLSX from 'xlsx';
import './App.css';
import { useDispatch } from 'react-redux';
import { addVa, getVa } from './features/slices';

function xoaKiTuKhongUTF8(chuoi) {
    if (chuoi) {
        return chuoi.replace(/[^\x00-\x7F]/g, ''); // Giữ lại chỉ kí tự ASCII (0-127)
    } else {
        return ""
    }
}

function generateVariants(products) {
    const result = [];

    function generateVariant(currentVariant, currentIndex) {
        if (currentIndex === products.length) {
            result.push(currentVariant);
            return;
        }
        for (const option of products[currentIndex]) {
            generateVariant([...currentVariant, option], currentIndex + 1);
        }
    }

    generateVariant([], 0);

    return result;
}

function replaceUTF8(chuoi) {
    if (chuoi) {
        return chuoi.replace(/[^\x00-\x7F]/g, '');
    } else {
        return chuoi
    }
}


function Option1({ option, setOption, atribute, setAtribute }) {
    const dispatch = useDispatch()
    const [data, setData] = useState([]);

    const [price, setPrice] = useState(0)
    const [crawler, setCrawler] = useState("")
    const [dataVariable, setDataVariable] = useState([])
    const [name, setName] = useState('');
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOk = async () => {
        await dispatch(addVa({ name, variable: atribute, option }))
        await dispatch(getVa())
        handleClose();
    };

    const handleVariable = () => {
        if (option == "" || atribute == "") {
            return
        }
        const Aratribute = atribute.split('\n')
        const allData = []
        for (let _Aratribute of Aratribute) {
            if (_Aratribute.split(",").length > 0 && _Aratribute.split(",")[0] != "") {
                allData.push(_Aratribute.split(","))
            }
        }
        let variants = generateVariants(allData)
        variants = variants.map((_variants) => {
            let bonusPrice = 0
            for (let [_indVariants, __variants] of _variants.entries()) {
                if (__variants.includes("=")) {
                    _variants[_indVariants] = __variants.split("=")[0];
                    bonusPrice += parseFloat(__variants.split("=")[1])
                }
            }

            return [..._variants, parseFloat(price) + bonusPrice]
            // return [..._variants, bonusPrice]
        });

        setDataVariable(variants)
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const arrayBuffer = event.target.result;
            const reader2 = new Uint8Array(arrayBuffer); // Đổi tên biến data thành reader2
            const workbook = XLSX.read(reader2, { type: 'array' });

            // Lấy dữ liệu từ sheet đầu tiên của file Excel
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Chuyển dữ liệu từ sheet Excel thành mảng hoặc JSON
            const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            // Loại bỏ dòng header và dòng trống
            const filteredData = excelData.filter((row, index) => {
                // Dòng header
                if (index === 0) {
                    return false;
                }
                console.log(row)
                // Dòng trống
                return row.some(cellValue => cellValue !== null && cellValue !== "");
            });
            setData(filteredData)
            console.log(filteredData)
        };

        reader.readAsArrayBuffer(file);
    };

    const handleExport = async () => {
        let dataVariables = []
        let part = 1
        // const block = ["fuck", "cunt", "pussy", "shit", "f*ck", "fvck", "p*ssy", "sh*t", "pvssy", "cum", "c*m", "cvm", "dick", "d*ck", "s3x", "drug", "ass"]
        const header = [
            "ID", "Type", "SKU", "Name", "Published", "Is featured?", "Visibility in catalog",
            "Short description", "Description", "Date sale price starts", "Date sale price ends",
            "Tax status", "Tax class", "In stock?", "Stock", "Low stock amount",
            "Backorders allowed?", "Sold individually?", "Weight (kg)", "Length (cm)",
            "Width (cm)", "Height (cm)", "Allow customer reviews?", "Purchase note",
            "Sale price", "Regular price", "Categories", "Tags", "Shipping class",
            "Images", "Download limit", "Download expiry days", "Parent", "Grouped products",
            "Upsells", "Cross-sells", "External URL", "Button text", "Position",
            "Attribute 1 name", "Attribute 1 value(s)", "Attribute 1 visible", "Attribute 1 global",
            "Attribute 1 default", "Attribute 2 name", "Attribute 2 value(s)", "Attribute 2 visible",
            "Attribute 2 global", "Attribute 2 default", "Attribute 3 name", "Attribute 3 value(s)",
            "Attribute 3 visible", "Attribute 3 global", "Attribute 3 default", "Attribute 4 name", "Attribute 4 value(s)", "Attribute 4 visible", "Attribute 4 global",
            "Attribute 4 default", "Attribute 5 name", "Attribute 5 value(s)", "Attribute 5 visible", "Attribute 5 global",
            "Attribute 5 default", "Meta: hwp_product_gtin"
        ]
        for (const [indexData, row] of data.entries()) {
            try {
                let bblock = 0
                const skuTime = !crawler ? `nobody-${moment().unix()}${indexData}` : `${crawler}-${moment().unix()}${indexData}`
                let title = row?.[3].replace(/'/g, "").replace(/['.:"™]/g, "").replace(/_/g, "-").replace(/%/g, "Percent").replace(/SVG/g, "T-Shirt").replace(/PNG/g, "").replace(/[/]/g, " ").replace(/ \| /g, ",").replace(/[èé]/g, "e").replace(/ & /g, " and ").replace(/&/g, " and ")
                title = title.charAt(0).toUpperCase() + title.slice(1);

                const description = row[8]
                const image = row[29].split(',');
                let sku = 0
                let newValue = []
                newValue = [skuTime, "variable", skuTime, replaceUTF8(title), row?.[4], row?.[5], row?.[6], row?.[7], replaceUTF8(row?.[8]), row?.[9], row?.[10], row?.[11], row?.[12], row?.[13], row?.[14], row?.[15], row?.[16], row?.[17], row?.[18], row?.[19], row?.[20], row?.[21], row?.[22], row?.[23], row?.[24], null, row?.[26], row?.[27], row?.[28], row?.[29], row?.[30], row?.[31], row?.[32], row?.[33], row?.[34], row?.[35], row?.[36], row?.[37], 0]
                for (let [indOption, _optine] of option.split(",").entries()) {
                    let atr1 = atribute.split("\n")[indOption].split(",");
                    for (let i = 0; i < atr1.length; i++) {
                        if (atr1[i].includes("=")) {
                            atr1[i] = atr1[i].split("=")[0];
                        }
                    }
                    newValue.push(_optine, atr1.join(","), 1, 1, dataVariable[0][indOption])
                }
                dataVariables.push(newValue)
                for (let [indDataVariable, _dataVariable] of dataVariable.entries()) {
                    let _newValue = [`${skuTime}-${indDataVariable}`, "variation", `${skuTime}-${indDataVariable}`, replaceUTF8(title), row?.[4], row?.[5], row?.[6], row?.[7], null, row?.[9], row?.[10], row?.[11], "parent", row?.[13], row?.[14], row?.[15], row?.[16], row?.[17], row?.[18], row?.[19], row?.[20], row?.[21], row?.[22], row?.[23], row?.[24], _dataVariable[_dataVariable.length - 1], null, null, null, null, null, null, skuTime, row?.[33], row?.[34], row?.[35], row?.[36], row?.[37], indDataVariable + 1]
                    for (let [indOption, _optine] of option.split(",").entries()) {
                        _newValue.push(_optine, _dataVariable[indOption], "", 1, "")
                    }
                    dataVariables.push(_newValue)
                }
            } catch (error) {
                console.log(error)
            }
        }
        const combinedData = [header, ...dataVariables];;
        const ws = XLSX.utils.aoa_to_sheet(combinedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, `tiktok_${part}.csv`);
    };

    const handleExport2 = async () => {
        // const combinedData = data
        // const ws = XLSX.utils.aoa_to_sheet(combinedData);
        // const wb = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        // XLSX.writeFile(wb, `tiktok_.csv`);
        let newData = []
        for (let _data of data) {
            newData.push([_data[0], _data[1], _data[2], _data[3], _data[4] + "hello", _data[5] + "hello", _data[6], _data[7] + "hello", _data[8] + "hello"])
        }
        console.log(newData)

    }

    const handleExportShopify = async () => {
        let dataVariables = []
        // Header cho Shopify CSV
        const shopifyHeaders = [
            "Handle",
            "Title",
            "Body (Html)",
            "Vendor",
            "Product Category",
            "Type",
            "Tags",
            "Published",
            "Option1 Name",
            "Option1 Value",
            "Option2 Name",
            "Option2 Value",
            "Option3 Name",
            "Option3 Value",
            "Variant Sku",
            "Variant Grams",
            "Variant Inventory Tracker",
            "Variant Inventory Qty",
            "Variant Inventory Policy",
            "Variant Fulfillment Service",
            "Variant Price",
            "Variant Compare At Price",
            "Variant Requires Shipping",
            "Variant Taxable",
            "Variant Barcode",
            "Image Src",
            "Image Position",
            "Image Alt Text",
            "Gift Card",
            "Google Shopping / Mpn",
            "Google Shopping / Age Group",
            "Google Shopping / Gender",
            "Google Shopping / Google Product Category",
            "Seo Title",
            "Seo Description",
            "Google Shopping / Adwords Grouping",
            "Google Shopping / Adwords Labels",
            "Google Shopping / Condition",
            "Google Shopping / Custom Product",
            "Google Shopping / Custom Label 0",
            "Google Shopping / Custom Label 1",
            "Google Shopping / Custom Label 2",
            "Google Shopping / Custom Label 3",
            "Google Shopping / Custom Label 4",
            "Variant Image",
            "Variant Weight Unit",
            "Variant Tax Code",
            "Cost Per Item",
            "Included / United States",
            "Included / International",
            "Template",
            "Shipping Profile Name",
            "Variant Tag",
            "Facebook Pixel Id",
            "Facebook Access Token",
            "Status",
            "Shipping Fee",
            "Base Cost Variant"
        ];

        // Tạo dữ liệu cho Shopify
        const shopifyData = [];

        // Thêm header
        shopifyData.push(shopifyHeaders);
        console.log(dataVariable)
        console.log(option)
        console.log(option.split(",").length)
        const nameOption = option.split(",")

        for (const [indexData, row] of data.entries()) {
            try {
                const skuTime = `SHO${moment().unix()}${indexData}`
                let title = row?.[3]
                title = title.charAt(0).toUpperCase() + title.slice(1);
                shopifyData.push([skuTime, title, row[8], "Acme", row[26], row[26], "", "TRUE", nameOption[0], dataVariable[0][0], option.split(",").length > 2 ? nameOption[1] : "", option.split(",").length > 2 ? dataVariable[0][1] : "", option.split(",").length > 3 ? nameOption[2] : "", option.split(",").length > 3 ? dataVariable[0][2] : "", skuTime, "0", "", "0", "deny", "manual", dataVariable[0][option.split(",").length], "", "TRUE", "TRUE", "", row[29].split(",")[0], "1", "", "FALSE", "", "", "", "212", "", "", "", "", "", "FALSE", "", "", "", "", "", "", "kg", "", "0", "TRUE", "TRUE", "Default", "", "", "", "", "active", "", ""])

                for (let [indDataVariable, _dataVariable] of dataVariable.entries()) {
                    if (indDataVariable == 0) {
                        continue
                    }
                    shopifyData.push([skuTime, "", "", "", "", "", "", "", "", _dataVariable[0], "", option.split(",").length > 2 ? _dataVariable[1] : "", "", option.split(",").length > 3 ? _dataVariable[2] : "", `${skuTime}-${indDataVariable}`, "0", "", "0", "deny", "manual", _dataVariable[option.split(",").length], "", "TRUE", "TRUE", "", row[29].split(",")[indDataVariable] ? row[29].split(",")[indDataVariable] : "", row[29].split(",")[indDataVariable] ? indDataVariable : "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "kg", "", "0", "TRUE", "TRUE", "Default", "", "", "", "", "", "0", "0"])
                }
            } catch (error) {
                console.log(error)
            }
        }

        // TODO: Thêm logic xử lý dữ liệu sản phẩm và variations ở đây
        // Bạn có thể tự implement phần này

        // Xuất file CSV
        const ws = XLSX.utils.aoa_to_sheet(shopifyData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Shopify Products');
        XLSX.writeFile(wb, `shopify_products_${Date.now()}.csv`);
    }
    return (
        <Box sx={{ width: '100%', height: '100%', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
            <NotificationContainer />

            <Box sx={{ p: 3, mb: 3, mx: 3, backgroundColor: '#ffffff' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                    Upload File
                </Typography>
                <Button
                    variant="contained"
                    component="label"
                    sx={{
                        background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                        }
                    }}
                >
                    Chọn File Excel
                    <input
                        type="file"
                        hidden
                        onChange={handleFileUpload}
                        accept=".xlsx,.xls"
                    />
                </Button>
            </Box>

            <Box sx={{ p: 3, mb: 3, mx: 3, backgroundColor: '#ffffff' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                    Cấu hình Options
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <TextField
                        label="Danh sách option (Style, Color, Size...)"
                        fullWidth
                        value={option}
                        onChange={(e) => setOption(e.target.value)}
                        placeholder="Ví dụ: Style,Color,Size"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: '#1976d2',
                                },
                            }
                        }}
                    />
                </Box>

                <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <TextField
                        label="Danh sách Attribute mỗi Option"
                        fullWidth
                        multiline
                        value={atribute}
                        onChange={(e) => setAtribute(e.target.value)}
                        rows={4}
                        placeholder="Mỗi dòng khai báo cho 1 option"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: '#1976d2',
                                },
                            }
                        }}
                    />
                    <Button
                        variant="contained"
                        onClick={handleClickOpen}
                        sx={{
                            minWidth: 100,
                            alignSelf: 'flex-start',
                            mt: 1,
                            background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                            }
                        }}
                    >
                        Lưu
                    </Button>
                </Box>
            </Box>

            <Box sx={{ p: 3, mb: 3, mx: 3, backgroundColor: '#fff9e6' }}>
                <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 600, color: '#d97706' }}>
                    📝 Ví dụ
                </Typography>
                <Typography variant="body2" sx={{ mb: 1.5, color: '#666' }}>
                    Danh sách Attribute có 2 color White và Black, size có S và L, nếu size L tăng 2 giá thì khai báo:
                </Typography>
                <Box sx={{ backgroundColor: '#fff', p: 1.5, fontFamily: 'monospace' }}>
                    <Typography variant="body2" sx={{ color: "#EC6A52", mb: 0.5 }}>
                        White,Black
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#EC6A52" }}>
                        S,L=2
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ p: 3, mb: 3, mx: 3, backgroundColor: '#ffffff' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                    Cấu hình Crawler
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: "#EC6A52", fontWeight: 500 }}>
                    Lưu ý: Tên người Crawler không dấu, không cách, không kí tự đặc biệt, không viết hoa
                </Typography>
                <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <TextField
                        label="Tên người Crawler"
                        value={crawler}
                        onChange={(e) => setCrawler(e.target.value)}
                        sx={{
                            width: 250,
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: '#1976d2',
                                },
                            }
                        }}
                        placeholder="Ví dụ: thuong"
                    />
                    <TextField
                        label="Giá"
                        type="number"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        sx={{
                            width: 150,
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: '#1976d2',
                                },
                            }
                        }}
                    />
                    <Button
                        variant="contained"
                        onClick={handleVariable}
                        sx={{
                            flex: 1,
                            background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                            }
                        }}
                        size="large"
                    >
                        Sinh tệp biến thế
                    </Button>
                </Box>
            </Box>

            {dataVariable.length > 0 && (
                <Box sx={{ p: 3, mb: 3, mx: 3, backgroundColor: '#ffffff' }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                        Kết quả
                    </Typography>
                    <TextField
                        label="Danh sách Attribute đã tạo"
                        fullWidth
                        value={dataVariable.join("\n")}
                        multiline
                        rows={8}
                        InputProps={{
                            readOnly: true,
                        }}
                        sx={{
                            '& .MuiInputBase-input': {
                                fontFamily: 'monospace',
                                fontSize: '0.875rem'
                            },
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: '#f8f9fa',
                            }
                        }}
                    />
                </Box>
            )}

            <Box sx={{ p: 3, mb: 3, mx: 3, backgroundColor: '#ffffff' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                    Xuất File
                </Typography>
                <Box sx={{ display: "flex", gap: 2, flexWrap: 'wrap' }}>
                    <Button
                        variant="contained"
                        onClick={handleExport}
                        size="large"
                        sx={{
                            minWidth: 150,
                            background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                            }
                        }}
                    >
                        Xuất WooCommerce
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleExport2}
                        size="large"
                        sx={{
                            minWidth: 150,
                            background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                            }
                        }}
                    >
                        Đọc File
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleExportShopify}
                        size="large"
                        sx={{
                            minWidth: 150,
                            background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                            }
                        }}
                    >
                        Xuất Shopify CSV
                    </Button>
                </Box>
            </Box>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Nhập Tên</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Tên"
                        type="text"
                        fullWidth
                        value={name}
                        onChange={event => setName(event.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Hủy
                    </Button>
                    <Button onClick={handleOk} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
export default Option1